import React from "react";
import { Link } from "react-router-dom";
import { PageHero, Section } from "../components/PageShell";
import { BUSINESS_AREAS } from "../data/site";
import { ArrowRight } from "lucide-react";

const BusinessAreas = () => (
    <>
        <PageHero
            eyebrow="Operating across multiple sectors"
            title="Business Areas"
            lead="Nador Sage International operates across automotive, energy, aviation, healthcare, and food sectors — providing trading, sourcing and supply chain coordination tailored to each industry."
        />

        <Section>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {BUSINESS_AREAS.map((b) => (
                    <Link
                        key={b.slug}
                        to={`/business-areas/${b.slug}`}
                        className="group block"
                        data-testid={`area-card-${b.slug}`}
                    >
                        <div className="aspect-[4/3] overflow-hidden bg-[var(--ns-paper)] border border-[var(--ns-border)]">
                            <img
                                src={b.image}
                                alt={b.title}
                                className="w-full h-full object-cover grayscale transition-transform duration-500 group-hover:scale-105"
                                loading="lazy"
                            />
                        </div>
                        <div className="pt-6">
                            <h2
                                className="font-display text-2xl font-bold tracking-tight"
                                style={{ color: "var(--ns-ink)" }}
                            >
                                {b.title}
                            </h2>
                            <p
                                className="font-body text-sm mt-2"
                                style={{ color: "var(--ns-muted)" }}
                            >
                                {b.teaser}
                            </p>
                            <span
                                className="mt-5 font-body text-sm font-medium inline-flex items-center gap-2 transition-transform group-hover:translate-x-1"
                                style={{ color: "var(--ns-ink)" }}
                            >
                                Learn more <ArrowRight size={14} />
                            </span>
                        </div>
                    </Link>
                ))}
            </div>
        </Section>
    </>
);

export default BusinessAreas;
